var _            = require('underscore');
var $            = require('jquery');
var Core         = require('../core/core.js');
var SwitcherItem = require('./switcher__item.js');
var EditorHolder = require('../editorHolder/editorHolder.js');
var Theme        = require('../theme/theme.js');

/**
 * Creates a footprint switcher
 *
 * @class
 */

class Switcher extends Core {

    _defaults() {
        return {
            target: '.js-editor',
            fields: {
                'canNotEdit': false
            }
        };
    }

    constructor(options) {
        super(options);

        this.template = `
            <div class='editor__switcher js-editor__switcher'>
                <div class='editor__switcher__content js-editor__switcher__content'></div>
                <div class='editor__switcher__sidebar js-editor__switcher__sidebar'>
                    <div class='editor__switcher__sidebar__items js-editor__switcher__sidebar__items'></div>
                    <% if(!canNotEdit) { %>
                        <div class='editor__switcher__sidebar__buttons js-editor__switcher__sidebar__buttons'>
                            <a class='editor__switcher__sidebar__buttons__button js-editor__switcher__sidebar__buttons__delete' title='Delete'>
                                <%= embedded_svg('icon-trash.svg') %>
                            </a>
                            <!--
                            <a class='editor__switcher__sidebar__buttons__button js-editor__switcher__sidebar__buttons__up' title='Move Up'>
                                <%= embedded_svg('icon-layer-upward.svg') %>
                            </a>
                            <a class='editor__switcher__sidebar__buttons__button js-editor__switcher__sidebar__buttons__down' title='Move Down'>
                                <%= embedded_svg('icon-layer-downward.svg') %>
                            </a>
                            -->
                        </div>
                    <% } %>
                </div>
            </div>
        `;

        super.render();

        $('.js-editor__switcher__sidebar__buttons__delete', this.$el).on('click', this._deleteClicked);
        $('.js-editor__switcher__sidebar__buttons__up', this.$el).on('click', this._upClicked);
        $('.js-editor__switcher__sidebar__buttons__down', this.$el).on('click', this._downClicked);

        //update style in view mode
        $('.editor__switcher__sidebar__items').css({'bottom': '0px', 'overflow-x': 'hidden'});
    }


    addItem(level, idx, title, thumbUrl, data){
        return new SwitcherItem({   //TODO make sure switcherItem is added on the right position on its level
            target: $('.js-editor__switcher__sidebar__items', this.$el),
            fields: {
                'level': level,
                'multilevel': this.multiLevel,
                'title': title,
                'thumbUrl': thumbUrl,
                'data': data
            }
        });
    }

    /**
     * @event Switcher#Cioui:SwitcherDelete:clicked
     * @property {String}Cioui:SwitcherDelete:clicked
     * @returns {Object} event - native click Event
     */

    _deleteClicked(e){
        e.preventDefault();
        $(e.currentTarget).trigger('Cioui:SwitcherDelete:clicked', e);
    }

    /**
     * @event Switcher#Cioui:SwitcherDelete:clicked
     * @property {String}Cioui:SwitcherDelete:clicked
     * @returns {Object} event - native click Event
     */

    _upClicked(e){
        e.preventDefault();
        $(e.currentTarget).trigger('Cioui:SwitcherUp:clicked', e);
    }

    /**
     * @event Switcher#Cioui:SwitcherDelete:clicked
     * @property {String}Cioui:SwitcherDelete:clicked
     * @returns {Object} event - native click Event
     */

    _downClicked(e){
        e.preventDefault();
        $(e.currentTarget).trigger('Cioui:SwitcherDown:clicked', e);
    }

    /**
     * Add an Editor Holder to the tab
     */
    addEditorHolderTemplate(){
        return new EditorHolder({
            target: $('.js-editor__switcher__content', this.$el)
        });
    }

    /**
     * Get the container for the sidebar
     */
    getSidebarYield(){
        return $('.js-editor__switcher__sidebar', this.$el);
    }

    /**
     * Clear all the sidebar items
     */
    clearItems(){
        $('.js-editor__switcher__sidebar__items', this.$el).empty();
    }

    /**
     * Set the tab theme
     */
    setTheme(theme){
        Theme(theme, this.$el);
    }

    /**
     * Show the switcher
     */
    show(){
        $('.js-editor__switcher__sidebar', this.$el).show();
        $('.js-editor__switcher__content', this.$el).css("right", 185);
    }

    /**
     * Hide the switcher
     */
    hide(){
        $('.js-editor__switcher__sidebar', this.$el).hide();
        $('.js-editor__switcher__content', this.$el).css("right", 0);
    }

}
module.exports = Switcher;